<template>
	<div>
		<topTab ref="topTab" :tabData='tabData' @tabChange='changePages'>
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="业务名称：">
					<el-input size="small" @keyup.enter.native="search" v-model="formInline.name"
						placeholder="请输入业务名称"></el-input>
				</el-form-item>
				<el-form-item label="业务编号：">
					<el-input size="small" @keyup.enter.native="search" v-model="formInline.code"
						placeholder="请输入业务编号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" class="el-icon-search" @click="search()">
						搜索
					</el-button>
					<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
				</el-form-item>
				<el-form-item style="float: right;margin-right: 0;">
					<el-button size="small" type="primary" class="el-icon-plus" @click="handleAdd()">新增
					</el-button>
					<!-- <el-button size="small" plain icon="el-icon-search">高级筛选</el-button> -->
					<my-column-filter :listColumns="listColumns" @hidePop="getCheckBox"></my-column-filter>
				</el-form-item>
			</el-form>
			<!--列表-->
			<STable ref="STable" :columns="columnsData" :data="listData" @getData="getListData" :loading="loading"
				@handleOperation="handleRowClick">
			</STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
		</topTab>
		<!-- 编辑 -->
		<edit ref="edit"></edit>
	</div>
</template>

<script>
	import {
		GetSystemBusinessConfigList
	} from '../../../api/systemApi.js';
	import edit from './edit';
	export default {
		data() {
			return {
				activeTab: '1',
				tabData: [{
					key: '1',
					value: '业务配置列表'
				}],
				pageShow: true,
				loading: false, // 显示加载
				expandAll: true,
				// 分页参数
				pageparm: {
					pageIndex: 1,
					pageSize: 15,
					total: 0
				},
				formInline: {
					pageIndex: 1,
					pageSize: 15,
					name: ''
				},
				listData: [],
				columnsData: [], //显示列
				listColumns: [{
						prop: 'rowNumber',
						label: '序号',
						align: 'center',
						fixed: 'left',
						width: '80',
						isKeep: true
					}, {
						prop: 'name',
						label: '业务名称',
						isKeep: true
					}, {
						prop: 'code',
						label: '业务编号',
						isKeep: true
					},
					{
						prop: 'valueStr',
						label: '业务值',
					}, {
						prop: 'businessConfigTypeStr',
						label: '业务配置类型',
					}, {
						prop: 'descrption',
						label: '业务描述',
					},
					{
						operationC: true,
						label: '操作',
						isKeep: true,
					}
				],
			};
		},
		// 注册组件
		components: {
			edit
		},
		created() {
			// 初始列
			this.getCheckBox(this.listColumns.map(item => item.label))
			this.getListData();
		},
		computed: {},
		methods: {
			// 获取筛选框
			getCheckBox(val) {
				let arr = this.listColumns.filter(v => !val.includes(v.label))
				this.columnsData = this.listColumns.filter(i => !arr.includes(i));
			},
			// 顶部tab页面切换
			changePages(tab) {},

			// 点击新增
			handleAdd() {
				this.$refs.edit.editShow();
			},

			// 单击行数据
			handleRowClick(row) {
				this.$refs.edit.editShow(row);
			},

			// 重置
			clearAll() {
				this.$data.formInline = this.$options.data.call(this).formInline
				this.search();
			},

			// 搜索事件
			search() {
				this.formInline.pageIndex = 1;
				this.pageShow = false;
				this.$nextTick(() => {
					this.pageShow = true;
				});
				this.getListData();
			},

			// 获取列表
			getListData() {
				this.listData = [];
				this.loading = true;
				GetSystemBusinessConfigList(this.formInline)
					.then((res) => {
						this.loading = false;
						if (res.code == 1) {
							this.listData = res.data;
							this.pageparm.total = res.totalNumber;
						} else {
							this.$message({
								type: 'info',
								message: res.msg,
							});
						}
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error('数据加载失败，请稍后再试！');
					});
			},

			// 分页插件事件
			callFather(parm) {
				if (parm.currentPage == undefined) {
					this.formInline.pageIndex = 1;
				} else {
					this.formInline.pageIndex = parm.currentPage;
				}
				this.formInline.pageSize = parm.pageSize;
				this.getListData();
			},

		},
	};
</script>

<style scoped></style>